import {
    LINKS_ONLY_BANNER_SIZE_TIER,
    LINKS_ONLY_MAX_SEGMENTS,
    LINKS_ONLY_SEGMENT_TYPES
} from "@/common/fields/display-modes";

import { sliderSizeTiers } from "@/components/catalog/sliders";

export const isLinksOnlyBannerStyle = (style) =>
    sliderSizeTiers[style] === LINKS_ONLY_BANNER_SIZE_TIER;

export const isSegmentAllowedInLinksOnly = (segment) => {
    if (!segment || !LINKS_ONLY_SEGMENT_TYPES.includes(segment.type)) {
        return false;
    }
    return segment.type !== "banners" || isLinksOnlyBannerStyle(segment.style);
};

// Devuelve el `reason` de DISPLAY_MODE_SEGMENTS_INVALID o null si cumple.
export const linksOnlySegmentsViolation = (segments = []) => {
    const list = segments || [];
    if (list.length > LINKS_ONLY_MAX_SEGMENTS) return "max-segments";
    if (
        list.some(
            (segment) => !LINKS_ONLY_SEGMENT_TYPES.includes(segment?.type)
        )
    ) {
        return "segment-type";
    }
    if (list.some((segment) => !isSegmentAllowedInLinksOnly(segment))) {
        return "banner-style";
    }
    return null;
};
